import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import apiToken, {
  isSuccess,
  handleApiError,
} from '@/shared/services/axiosInstance';
import { useValidateContact } from './useValidateContact';

export const useHandleSubmit = () => {
  const navigate = useNavigate();
  const [contactUsForm, setContactUsForm] = useState({
    email: '',
    companyName: '',
    representativeName: '',
    phoneNumber: '',
    businessRegistrationNumber: '',
    termsOfServiceAgree: false,
    content: '',
  });
  const { validateContact, errors } = useValidateContact(contactUsForm);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const { name, value, type } = e.target;
    let newValue: string | boolean = value;
    if (type === 'checkbox') {
      // checked only exists on HTMLInputElement
      newValue = (e.target as HTMLInputElement).checked;
    }
    setContactUsForm((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  // Your implementation here
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validateContact()) {
      try {
        const response = await apiToken.post('/api/v1/contact', contactUsForm);
        if (isSuccess(response.data)) {
          alert('your inquiry has been submitted successfully.');
          navigate('/');
        }
      } catch (error) {
        const errorMessage = handleApiError(error);
        console.error('Failed to submit contact form:', errorMessage);
      }

      // TODO: 실제 제출 로직 (API 호출 등)
    }
  };

  return {
    handleSubmit,
    contactUsForm,
    errors,
    setContactUsForm,
    handleInputChange,
  };
};
